import { api } from "./client";

export interface DiscountReportItem {
  bill_id: number;
  closed_at: string | null;
  total_amount: number;
  discount_percent: number;
  total_discount: number;
  paid_amount: number;
  /** Кой е ПРИЛОЖИЛ отстъпката — може да е управител на чужда маса. */
  waiter_id: number | null;
  waiter_name: string | null;
  /** Сервитьорът НА СМЕТКАТА и името на масата (BE 0.0.224). По първото се
   *  групира „По сервитьори"; по второто се показва масата вместо „#123". */
  bill_waiter_id?: number | null;
  bill_name?: string | null;
  /** Броят гости по сметката (`bills.guests`); null = не е въвеждан. */
  guests?: number | null;
  client_id: number | null;
  client_name: string | null;
  discount_type: string | null;
  restaurant_id: number | null;
  restaurant_name: string | null;
}

export interface DiscountReportResponse {
  items: DiscountReportItem[];
  total: number;
}

export interface DiscountReportFilters {
  start_date?: string;
  end_date?: string;
}

export const getDiscountsReport = async (
  filters?: DiscountReportFilters,
): Promise<DiscountReportItem[]> => {
  const params = new URLSearchParams();
  if (filters?.start_date) params.append("start_date", filters.start_date);
  if (filters?.end_date) params.append("end_date", filters.end_date);

  const response = await api.get<DiscountReportResponse>(
    `/reports/analytics/discounts${params.toString() ? `?${params.toString()}` : ""}`,
  );
  return response.data.items;
};
